export default __webpack_public_path__ + "static/media/remove-dependency.1866dd40.svg";